import type { MouseEvent } from "react";
import type React from "react";
import { useState } from "react";
import { WizardLegendItem } from "@similarweb/ui-components";
import type { EWizardLegendItemState } from "app/pages/digital-suite/home-page/components/ActivationWizard/Components/Step";
import { StepHeaderWrapper, Title } from "./StepHeaderStyled";
import {
    BodyStep,
    ButtonStyle,
    IconIsAllSkipped,
    IconStep,
    SkipText,
} from "app/pages/digital-suite/home-page/components/ActivationWizard/Components/StepCloseStyled";
import { colorsPalettes } from "@similarweb/styles";
import I18n from "pro-features/components/WithTranslation/src/I18n";

interface IStepHeader {
    onClick: () => void;
    title: string;
    itemState: EWizardLegendItemState;
    stepIndex: number;
    buttonText: string;
    isButtonShowAlways?: boolean;
    isSkip: boolean;
    isAllSkipped?: boolean;
    isOpen: boolean;
}
export const StepHeader: React.FC<IStepHeader> = ({
    onClick,
    title,
    itemState,
    stepIndex,
    isOpen,
    buttonText,
    isButtonShowAlways = false,
    isSkip,
    isAllSkipped = false,
}) => {
    const [isHover, setIsHover] = useState<boolean>(false);

    const toggleHover = (ev: MouseEvent, isHover: boolean) => {
        ev.preventDefault();
        setIsHover(isHover);
    };

    const onButtonClick = (ev: MouseEvent) => {
        ev.stopPropagation();
        onClick();
    };

    return (
        <StepHeaderWrapper
            onClick={onClick}
            style={{ cursor: isOpen ? "" : "pointer" }}
            onMouseEnter={(e) => toggleHover(e, true)}
            onMouseLeave={(e) => toggleHover(e, false)}
        >
            <BodyStep>
                {!isAllSkipped ? (
                    <IconStep>
                        <WizardLegendItem
                            legendStepIndex={stepIndex}
                            label={""}
                            itemState={itemState}
                            showHoverIcon={false}
                            onClickFunc={null}
                            isStepCompleted={false}
                        />
                    </IconStep>
                ) : (
                    <IconIsAllSkipped
                        iconName={"clear"}
                        iconSize={"xs"}
                        iconColor={colorsPalettes.carbon[0]}
                    />
                )}
                <Title isOpen={isOpen}>{title}</Title>
                {isSkip ? (
                    <SkipText>
                        <I18n>growth.homepage.activationWizard.skipInTheTitle</I18n>
                    </SkipText>
                ) : null}
            </BodyStep>
            {(isHover || isButtonShowAlways) && !isOpen ? (
                <ButtonStyle
                    isHoverStep={isHover}
                    type={"flat"}
                    height={"36px"}
                    onClick={onButtonClick}
                >
                    {buttonText}
                </ButtonStyle>
            ) : null}
        </StepHeaderWrapper>
    );
};
